import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { Suspense } from "react";
import { UserSourcesFeatureUnavailable } from "@/app/user-sources/components/user-sources-feature-unavailable";
import { UserSourcesListSkeleton } from "@/app/user-sources/components/user-sources-list-skeleton";
import { useUserSourcesEnabled } from "@/app/user-sources/hooks/use-user-sources-enabled";
import { UserSourcesList } from "@/app/user-sources/list";
import {
  userSourcesSearchDefaults,
  userSourcesSearchSchema,
} from "@/app/user-sources/search-params";

function UserSourcesPage() {
  const enabled = useUserSourcesEnabled();
  if (!enabled) {
    return <UserSourcesFeatureUnavailable />;
  }
  return (
    <Suspense fallback={<UserSourcesListSkeleton />}>
      <UserSourcesList />
    </Suspense>
  );
}

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/user-sources"
)({
  validateSearch: zodValidator(userSourcesSearchSchema),
  search: {
    middlewares: [stripSearchParams(userSourcesSearchDefaults)],
  },
  component: UserSourcesPage,
  loader: () => ({
    crumb: "User sources",
  }),
});
